import Button from "@/base-components/Button"
import Lucide from "@/base-components/Lucide"
import { useUserProfile } from "@/hooks/useUserProfile"
import { truncate } from "@/utils/constants"
import displayOdds from "@/utils/displayOdds"
import { readableDate, timeAgo } from "@/utils/helper"
import { useUser } from "@auth0/nextjs-auth0/client"
import Link from "next/link"
import React from "react"

const index = ({ bet }) => {
  const { user, isLoading } = useUser()
  const { data: profile } = useUserProfile()

  return (
    <div className="grid w-full grid-cols-[minmax(0,1.5fr)_minmax(0,3.5fr)_minmax(0,1.5fr)_minmax(0,2.3fr)_minmax(0,0.5fr)_minmax(0,1.2fr)_minmax(0,1.5fr)] bg-dark-8 rounded-md hover:cursor-pointer hover:bg-white/5 ">
      <div className="px-3 py-3  flex flex-col justify-center items-center border-b-0">
        <div className="font-medium text-sm whitespace-wrap">
          {`${bet.ev}%`}
        </div>
        <div className="text-slate-500 blur-sm  text-xs whitespace-nowrap mt-0.5">
          {`Updated ${timeAgo(bet.bet_age)}`}
        </div>
      </div>
      <div className="px-3 py-3 flex flex-col justify-center  border-b-0">
        <div className="text-slate-500 blur-sm  text-xs whitespace-nowrap mt-0.5">
          {/* {`${readableDate(bet.match_date, user.timezone)}`} */}
          Today, 18 Nov at 6PM
        </div>
        <div className="font-medium  blur-sm  text-sm whitespace-wrap ">
          {/* {bet.event || `${bet.teamA} vs ${bet.teamB}`} */}
          Liverpool vs Manchester City
        </div>
        <div className="text-slate-500 text-xs whitespace-nowrap mt-0.5">
          {bet.sport_name} | {truncate(bet.country, 15)} |{" "}
          {truncate(bet.competition, 15)}
        </div>
      </div>

      <div className="px-3 py-3  text-center flex flex-col justify-center items-center text-sm  border-b-0">
        <div className="font-medium text-sm  blur-sm  whitespace-wrap">
          Market goes here
        </div>
        <div className="text-slate-500 text-xs  blur-sm  whitespace-nowrap mt-0.5">
          Scoreboard goes here
        </div>
      </div>
      <div className="px-3 py-3  blur-sm  text-center text-sm  border-b-0 flex flex-col justify-center items-center">
        the bet goes here
      </div>
      <div className="px-3 py-3    text-center text-sm  border-b-0 flex flex-col justify-center items-center">
        {displayOdds(profile?.oddsFormat, bet.odds)}
      </div>

      <div className="px-3 py-3  text-center flex flex-col justify-center items-center  border-b-0">
        <div>{bet.bookmaker2}</div>
      </div>
      <div className="px-3 py-3   blur-sm pointer-events-none flex flex-col justify-center items-center  border-b-0 py-0 relative before:block before:w-px before:h-8 before:bg-white/[0.12] before:absolute before:left-0 before:inset-y-0 before:my-auto before:dark:bg-darkmode-400">
        <div className="flex items-center justify-between">
          <Link href={bet.url2} legacyBehavior>
            <a target="_blank" rel="noopener noreferrer">
              <Button
                onClick={e => {
                  e.stopPropagation()
                }}
                title="View match on Bookmaker"
                className="justify-between  items-center bg-slate-100/10 transition duration-200 border-none inline-flex  font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none dark:focus:ring-slate-700 dark:focus:ring-opacity-50 [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 [&:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed text-xs py-[.45rem] px-1 rounded-md text-md !shadow-none whitespace-nowrap"
              >
                <span className="mr-1 text-purple-light">BET</span>
                <Lucide
                  className="text-purple-light mr-0"
                  icon="ExternalLink"
                />
              </Button>
            </a>
          </Link>
          <Button
            onClick={e => {
              e.stopPropagation()
              // setBet(bet)
              // setHideBetModal(true)
            }}
            title="Hide"
            className=" justify-between items-center hover:bg-slate-100/10 transition duration-200 border-none inline-flex  font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none dark:focus:ring-slate-700 dark:focus:ring-opacity-50 [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 [&:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed text-xs py-[.45rem] px-1 rounded-md text-md !shadow-none whitespace-nowrap"
          >
            <Lucide className="text-purple mr-0" icon="EyeOff" />
          </Button>{" "}
          <Button
            onClick={e => {
              e.stopPropagation()
              // setBet(bet)
              // setShowAddBetToTracker(true)
            }}
            title="Add to Tracker"
            className=" justify-between items-center hover:bg-slate-100/10 transition duration-200 border-none inline-flex  font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none dark:focus:ring-slate-700 dark:focus:ring-opacity-50 [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 [&:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed text-xs py-[.45rem] px-1 rounded-md text-md !shadow-none whitespace-nowrap"
          >
            <Lucide className="text-purple-dark mr-0" icon="CirclePlus" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default index
